import {
  styled,
  DesignTokenSizeEnum,
  FullscreenLayer as VWGFullscreenLayer,
  type FullscreenLayerProps as VWGFullscreenLayerProps,
} from '@volkswagen-onehub/components-core';
import { PropsWithChildren } from 'react';
import useFullscreen from '@/hooks/useFullscreen';
import zIndex from '@/modules/constants/zIndex';
import Box from '../Box/Box';

export type FullscreenLayerProps = VWGFullscreenLayerProps &
  PropsWithChildren<{
    offsetTop?: keyof typeof DesignTokenSizeEnum;
  }>;

const StyledBox = styled.div`
  > div {
    z-index: ${zIndex.MODAL};
  }
`;

const ContentWraper = styled.div`
  background: linear-gradient(0deg, #E8E3D9 0.11%, rgba(232, 227, 217, 0) 75.62%);
  background-blend-mode: multiply;

`;

const FullscreenLayer = ({
  children,
  offsetTop = 'static530',
  ...restProps
}: FullscreenLayerProps) => {
  useFullscreen();

  return (
    <StyledBox data-testid="fullscreen-layer">
      <VWGFullscreenLayer {...restProps}>
        <Box paddingTop={offsetTop} height="100%">
          <ContentWraper>
            {children}  
          </ContentWraper>
        </Box>
      </VWGFullscreenLayer>
    </StyledBox>
  );
};

export default FullscreenLayer;
